import {Vue, Component} from 'vue-property-decorator'
import {
  ParamSet,
} from '@/params'
import type {RepresentationElement} from 'ngl'
import type {ComponentType} from '@/store/shots'
import ParamsUtils from '@/components/NGL/ParamsUtils'

@Component({})
export default class ParamsMixin extends Vue {
  createRepresentationParams(element: RepresentationElement, compType: ComponentType): ParamSet {
    return ParamsUtils.createRepresentationParams(element, compType)
  }
}
